export const environment = {
  banner: {text: 'TEST'},
  idp_url: 'https://identity-eiam-a.eiam.admin.ch/realms/efd_bit-vlp',
  redirect_url: 'https://test.federalproof.ch',
  client_id: 'BIT-vlp',
	claims: ['given_name', 'family_name', 'email', 'acr', 'birthdate'],
  minimum_acr: 30,
  sentryEnvironment: 'test'
};
